import { Link } from 'gatsby';
import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import _ from 'lodash';
import { asyncTrackingEvent, asyncTrackingEventProps } from '../../app/utils/tracking';

type Props = {
  images?: any;
  columns?: string;
};

type LogoSplashType = {
  path: any;
  id: string;
  type: string;
  title: string;
  image: any;
  alias: any;
};

const LoadMore = ({ images, columns }: Props) => {
  const onClick = (item: LogoSplashType) => {
    const event: asyncTrackingEventProps = {
      track: 'logo_splash_click',
      trackAbacus: 'logo_splash_click',
      trackId: item.id,
      trackText: item.title,
      trackValue: item.type,
      trackUrl: item.alias
    };
    asyncTrackingEvent(event);
  };

  // Two column logo splash is restricted to showing a max of 12 logos
  const ImageCollection: any = columns === '2' && images?.length > 12 ? images.slice(0, 12) : images;

  return (
    <>
      {ImageCollection.map((image: any, imageIndex: number) => {
        return (
          <div
            key={imageIndex}
            className="flex justify-center justify-self-center items-center rounded-md shadow-md p-2 h-28 w-28 bg-white"
          >
            {image?.path?.alias ? (
              <Link to={image?.path?.alias} onClick={() => onClick(image)} data-cy={`link:more`}>
                {image?.image ? <GatsbyImage image={image.image} alt={image.title} /> : image?.title}
              </Link>
            ) : image?.alias ? (
              <Link to={image?.alias} onClick={() => onClick(image)} data-cy={`link:more`}>
                {image?.image ? <GatsbyImage image={image.image} alt={image.title} /> : image?.title}
              </Link>
            ) : (
              <>{image?.image ? <GatsbyImage image={image.image} alt={image.title} /> : image.title}</>
            )}
          </div>
        );
      })}
    </>
  );
};
export default LoadMore;
